// extracted by mini-css-extract-plugin
export default {"loadingFrame":"xxrlF0PJXfOfZl2H11HzwQ==","universityBlocker":"jF464wApZBv4sHY8aj+hTQ==","universityFrame":"KmAodhSO6aG0nqaJr7bsiQ=="};